<template>
  <div class="relative">
    <button
      :disabled="isCheckoutBusy || !areAllSectionsCompleted"
      class="button primary"
      :aria-busy="isCheckoutBusy"
      :aria-disabled="isCheckoutBusy || !areAllSectionsCompleted"
      :aria-label="`Place Order ${isCheckoutBusy ? ' (processing)' : ''}`"
      @click="$emit('placeOrderClicked')"
    >
      Place Order
    </button>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { toNumber } from 'lodash'

export default {
  name: 'PlaceOrderButton',
  computed: {
    ...mapGetters(['checkoutState', 'cart', 'isWorkGroupBusy']),
    isCheckoutBusy() {
      return this.isWorkGroupBusy('checkout')
    },
    isShippingSectionComplete() {
      const selectedMethod = this.checkoutState.shipping.selectedMethod
      const methods = this.checkoutState.shipping.methods
      if (selectedMethod === methods.address) {
        return !!this.checkoutState.shipping.selectedAddress
      } else if (selectedMethod === methods.fedex) {
        return !!this.checkoutState.shipping.selectedPickupAddress
      } else if (selectedMethod === methods.addressGift) {
        // yes, gift note is required, but let user submit without it to get error back
        return !!this.checkoutState.shipping.selectedAddress
      }
      return false
    },
    /**
     * Check the cart to see if there's an outstanding amount due, if not then don't disable place order
     * if there is an outstanding amount due and no payment selected then disable place order
     */
    paymentMethodSatisfied() {
      return (
        toNumber(this.cart.grand_total) <= 0 ||
        (this.checkoutState.payment &&
          this.checkoutState.payment.selectedPaymentMethod)
      )
    },
    areAllSectionsCompleted() {
      return (
        this.$auth.loggedIn &&
        this.isShippingSectionComplete &&
        this.paymentMethodSatisfied
      )
    },
  },
}
</script>
